<template>
    <div>

        <FullCalendar :options="calendarOptions" :event-sources="calendarOptions.events" />

        <button type="button" class="btn btn-primary mt-2" @click="addNewSlot()">Neuer Buchungsslot</button>

        <!-- Create Package Modal -->
        <div class="modal fade" id="modal-create-package" tabindex="-1" role="dialog">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            <div v-if="selectedEventType == 0">
                                <span v-if="!editEvent">Neuer Buchungsslot</span><span v-else>Buchungsslot bearbeiten</span>
                            </div>
                            <div v-else>
                                <span v-if="!editEvent">Neuer Buchungsslot</span><span v-else>Buchung bearbeiten</span>
                            </div>
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                    </div>

                    <div class="modal-body">

                        <div v-if="selectedBookingData" class="bg-soft-info p-2">
                            <strong>Buchungsdaten</strong>
                            <p><small v-html="selectedBookingData"></small></p>
                        </div>

                        <div class="form-group" v-if="!selectedBookingData">
                            <label class="col-form-label col-form-label-md">Typ:</label>
                            <select class="form-control" v-model="selectedEventType">
                                <option value="0">Intelligenter Buchungsslot</option>
                                <option value="1">Einfacher Buchungsslot (Leistungsgebunden)</option>
                            </select>
                        </div>


                        <!--<div class="form-group">
                            <label class="col-form-label col-form-label-md">Typ:</label>
                            <select class="form-control" v-model="selectedEventType">
                                <option value="0">Freier Buchungsslot</option>
                            </select>
                        </div>-->
                        <!--<div v-if="selectedEventType == 1">
                            <div class="form-row">
                                <div class="col">
                                    <label class="col-form-label col-form-label-md">Vorname:</label>
                                    <input type="text" v-model="booking.first_name" class="form-control form-control-sm">
                                </div>
                                <div class="col">
                                    <label class="col-form-label col-form-label-md">Nachname:</label>
                                    <input type="text" v-model="booking.last_name" class="form-control form-control-sm">
                                </div>
                            </div>
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">Adresse:</label>
                                <input type="text" v-model="booking.address" class="form-control form-control-sm">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">Postleitzahl:</label>
                                <input type="text" v-model="booking.zip" class="form-control form-control-sm">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">Ort:</label>
                                <input type="text" v-model="booking.city" class="form-control form-control-sm">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">Telefon:</label>
                                <input type="text" v-model="booking.phone" class="form-control form-control-sm">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">E-Mail:</label>
                                <input type="text" v-model="booking.email" class="form-control form-control-sm">
                            </div>
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">Personenzahl:</label>
                                <input type="text" v-model="booking.pax" class="form-control form-control-sm">
                            </div>
                        </div>-->
                        <div class="form-group">
                            <label class="col-form-label col-form-label-md"><span v-if="selectedDateEnd">Von </span>Datum:</label>
                            <input type="date" v-model="selectedDateStart" class="form-control form-control-sm">
                        </div>
                        <div class="form-group" v-if="selectedDateEnd">
                            <label class="col-form-label col-form-label-md">Bis Datum:</label>
                            <input type="date" v-model="selectedDateEnd" class="form-control form-control-sm">
                        </div>
                        <div class="form-group" v-if="selectedEventType == 1 && !selectedBookingData">
                            <label class="col-form-label col-form-label-md">Leistung auswählen:</label>
                            <select class="form-control" v-model="selectedService">
                                <option value="">Nicht an Leistung koppeln</option>
                                <option v-for="(item, key) in services" :value="item.id">{{ item.name }} ({{ item.duration}} min)</option>
                            </select>
                            <!--<small class="text-muted" style="line-height:normal;font-size:13px;font-weight:300;">Macht diesen Slot nur für die ausgewählte Leistung verfügbar. Booklyn versucht die verfügbare Zeit des Slots voll auszufüllen, d.h. wenn der Slot doppelt so lang ist wie die Leistung, kann die Leistung 2 auch mal hintereinander gebucht werden.</small>-->
                        </div>
                        <div class="form-group">
                            <label class="col-form-label col-form-label-md">Uhrzeit<span v-if="!selectedService"> von:</span></label>
                            <input type="time" v-model="selectedTimeStart" class="form-control form-control-sm">
                        </div>
                        <div v-if="!selectedService">
                            <div class="form-group">
                                <label class="col-form-label col-form-label-md">Uhrzeit bis:</label>
                                <input type="time" v-model="selectedTimeEnd" class="form-control form-control-sm">
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-form-label col-form-label-md">Maximale mögliche Buchungen (pro Slot):</label>
                            <input type="text" v-model="selectedMaxPax" class="form-control form-control-sm">
                            <p class="text-muted mt-1 mb-0" style="line-height:normal;font-size:13px;font-weight:300;">Wieviele Buchungen können paralell für diesen Slot angeboten werden. <br /><strong>Beispiel:</strong> Wenn ein Slot nach einer Buchung nicht mehr verfügbar sein sollte, geben Sie hier eine 1 ein. Ansonsten frei lassen für unendlich.</p>
                        </div>

                        <hr />

                        <div v-if="!editEvent">

                            <div class="form-check form-group">
                                <input type="checkbox" v-model="slotRepeatable" class="form-check-input" id="slotRepeatable">
                                <label class="form-check-label col-form-label-m" for="slotRepeatable">Wiederholender Termin?</label>
                            </div>
                            <div class="form-group" v-if="slotRepeatable">
                                <label class="col-form-label col-form-label-md">
                                    <select v-model="slotRepeatableInterval" style="border-color: #dee2e6;">
                                        <option value="daily">Täglich</option>
                                        <option value="weekly">Wöchentlich</option>
                                        <option value="monthly">Monatlich</option>
                                        <option value="mo-fr">Mo-Fr</option>
                                        <option value="mo-sa">Mo-Sa</option>
                                    </select>
                                wiederholen bis Datum:</label>
                                <input type="date" v-model="slotRepeatableIntervalDateEnd" class="form-control form-control-sm">
                            </div>

                        </div>

                    </div> <!-- /.modal-body -->

                    <!-- Modal Actions -->
                    <div class="modal-footer">
                        <button v-if="editEvent && selectedEventType == 0" type="button" class="btn btn-outline" style="flex-grow:1;flex-flow:column;" @click="deleteEvent(editEvent)"><span v-if="selectedEventType == 0">Slot</span><span v-else>Buchung</span> löschen</button>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Abbrechen</button>
                        <button id="buttonSavePackage" type="button" class="btn btn-primary" @click="addNewEvent()">Speichern</button>
                    </div>
                </div>
            </div>
        </div>

</div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction';

export default {
    
    components: {
        FullCalendar // make the <FullCalendar> tag available
    },

    data() {
        return {
            calendarOptions: {
                plugins: [ dayGridPlugin, timeGridPlugin, interactionPlugin ],
                initialView: 'dayGridMonth',
                locale: 'de',
                views: {
                    timeGridDay: { buttonText: 'Tag' },
                    timeGridWeek: { buttonText: 'Woche' },
                    dayGridMonth: { buttonText: 'Monat' }
                },
                headerToolbar: {
                    left: 'title',
                    center: '',
                    right: 'prev,next,timeGridDay,timeGridWeek,dayGridMonth'
                },
                weekNumbers: true,
                editable: true,
                selectable: true,
                dayMaxEvents: true,
                //navLinks: true, // can click day/week names to navigate views
                //initialEvents: INITIAL_EVENTS,
                dateClick: this.handleDateClick,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                eventsSet: this.handleEvents,
                eventDrop: this.handleEventDrop,
                events: []
            },
            services: [],
            selectedDateStart: '',
            selectedDateEnd: '',
            selectedTimeStart: '',
            selectedTimeEnd: '',
            selectedService: '',
            selectedMaxPax: '',
            selectedEventType: 0,
            selectedBookingData: '',
            editEvent: false,
            slotRepeatable: false,
            slotRepeatableInterval: 'daily',
            slotRepeatableIntervalDateEnd: '',
            /*booking: {
                first_name: '',
                last_name: '',
                address: '',
                zip: '',
                city: '',
                phone: '',
                email: '',
                pax: ''
            }*/
        }
    },

    created() {
        this.getEvents();
    },

    methods: {

        handleEventDrop(dropInfo) {
            console.log(dropInfo);

            var data = { startDate: dropInfo.event.start, eventId: dropInfo.event.id  }

            //console.log(data);

            axios.put('/api/events/'+this.calendarData.id+'?api_token='+this.apiToken, data)
            .then(function (response) {
                console.log(response);
            });

            //alert(dropInfo.event.id);
            
            /*this.editEvent = clickInfo.event.id;

            var m = '' + (clickInfo.event.start.getMonth() + 1),
            d = '' + clickInfo.event.start.getDate(),
            Y = clickInfo.event.start.getFullYear();
            if (m.length < 2) 
                m = '0' + m;
            if (d.length < 2) 
                d = '0' + d;
            this.selectedDateStart = Y + '-' + m + '-' + d;*/

        },

        getEvents() {

            var _this = this;
            axios.get('/api/events/'+this.calendarData.id+'?api_token='+this.apiToken)
            .then(function (response) {
                _this.calendarOptions.events = response.data;
            });

        },

        handleDateClick: function(arg) {
            //alert('date click! ' + arg.dateStr)
            //$('#modal-create-package').modal('show');
            //console.log(arg);
            //console.log(arg.dateStr);
            //this.clickedDate = arg.dateStr;
        },

        handleDateSelect(selectInfo) {

            this.editEvent = false;

            console.log(selectInfo);

            // reset
            this.selectedDateStart = false;
            this.selectedDateEnd = false;
            this.selectedTimeStart = '09:00';
            this.selectedTimeEnd = '18:00';
            this.selectedService = '';

            var diff = selectInfo.end.getTime() - selectInfo.start.getTime();
            if(diff == 86400000) { // use has selected only one day
                this.selectedDateStart = selectInfo.startStr;
                //this.selectedDateEnd = selectInfo.startStr;
            }
            else { // use has selected multiple days
                this.selectedDateStart = selectInfo.startStr;

                selectInfo.end.setDate(selectInfo.end.getDate() - 1);
                var m = '' + (selectInfo.end.getMonth() + 1),
                d = '' + selectInfo.end.getDate(),
                Y = selectInfo.end.getFullYear();
                if (m.length < 2) 
                    m = '0' + m;
                if (d.length < 2) 
                    d = '0' + d;
                //this.selectedDateEnd = Y + '-' + m + '-' + d;
                this.selectedDateEnd = false // temp
            }

            $('#modal-create-package').modal('show');

            /*let title = prompt('Please enter a new title for your event')
            let calendarApi = selectInfo.view.calendar;

            calendarApi.unselect() // clear date selection

            if (title) {
            calendarApi.addEvent({
            id: createEventId(),
            title,
            start: selectInfo.startStr,
            end: selectInfo.endStr,
            allDay: selectInfo.allDay
            })
            }*/
        },

        addNewSlot() {
            
            this.editEvent = false;
            this.selectedBookingData = '';

            // reset
            this.selectedDateStart = '2021-07-28';
            this.selectedDateEnd = false;
            this.selectedTimeStart = '09:00';
            this.selectedTimeEnd = '18:00';
            this.selectedService = '';

            $('#modal-create-package').modal('show');
        },

        addNewEvent() {

            var _this = this;
            var data = { startDate: this.selectedDateStart, endDate: this.selectedDateEnd, startTime: this.selectedTimeStart, endTime: this.selectedTimeEnd, service: this.selectedService, selectedPaxMax: this.selectedMaxPax, slotRepeatable: this.slotRepeatable, slotRepeatableInterval: this.slotRepeatableInterval, slotRepeatableIntervalDateEnd: this.slotRepeatableIntervalDateEnd, editEvent: this.editEvent }

            axios.post('/api/events/'+this.calendarData.id+'?api_token='+this.apiToken, data)
            .then(function (response) {
                console.log(response);
                if(_this.editEvent) {
                    // edit event
                    _this.getEvents();
                    /*console.log("editEvent" + _this.editEvent);
                    _this.calendarOptions.events.forEach(function(entry, index) {
                        if(entry.id == _this.editEvent) {
                            console.log("found" + entry.id);
                            console.log("index" + index);
                            _this.calendarOptions.events[index] = response.data;
                            _this.editEvent = false;
                        }
                    });*/
                }
                else {
                    // new event
                    console.log("add new event" + _this.editEvent);
                    //_this.calendarOptions.events.push(response.data);
                    _this.getEvents();
                }
            });
            $('#modal-create-package').modal('hide');

            /*var title;

            if(!this.selectedService)
                title = 'Freier Slot';
            else
                title = this.selectedService.title;
            
            var new_event = {
                title: 'Slot',
                url: 'http://google.com/',
                start: '2020-10-20'
            };

            this.calendarOptions.events.push(new_event);*/


          /*axios
            .post("/api/calendar", {
              ...this.newEvent
            })
            .then(data => {
              this.getEvents(); // update our list of events
              this.resetForm(); // clear newEvent properties (e.g. title, start_date and end_date)
            })
            .catch(err =>
              console.log("Unable to add new event!", err.response.data)
            );*/

        },


        handleEventClick(clickInfo) {
            //if (confirm(`Are you sure you want to delete the event '${clickInfo.event.title}'`)) {
            //  clickInfo.event.remove()
            // }
            //console.log(clickInfo.event.end);
            //console.log(clickInfo.event.startStr);
            console.log(clickInfo.event);
            console.log(clickInfo.event.extendedProps.event_type);

            if(clickInfo.event.extendedProps.event_type == 0) {
                //alert("Click auf freier Buchungsslot");
                this.selectedEventType = 0;
                this.selectedBookingData = '';
                this.slotRepeatable = '';
                this.slotRepeatableInterval = '';
                this.slotRepeatableIntervalDateEnd = '';
            }
            else { // click auf buchung
                this.selectedEventType = 1;
                // buchungsdaten laden
                var _this = this;
                axios.get('/api/booking/'+clickInfo.event._def.publicId+'?api_token='+this.apiToken)
                .then(function (response) {
                    console.log(response.data);
                    _this.selectedBookingData = response.data.bookingdata;
                    _this.phone = response.data.phone;
                    _this.email = response.data.email;
                    _this.smsContent = response.data.smsContent;
                    _this.emailContent = response.data.emailContent;
                    _this.smsContentCompleted = response.data.smsContentCompleted;
                    _this.emailContentCompleted = response.data.emailContentCompleted;
                });
                
            }

            this.editEvent = clickInfo.event.id;

            var m = '' + (clickInfo.event.start.getMonth() + 1),
            d = '' + clickInfo.event.start.getDate(),
            Y = clickInfo.event.start.getFullYear();
            if (m.length < 2) 
                m = '0' + m;
            if (d.length < 2) 
                d = '0' + d;
            this.selectedDateStart = Y + '-' + m + '-' + d;

            var hour = clickInfo.event.start.getHours();
            var min = clickInfo.event.start.getMinutes();
            if (hour < 10) 
                hour = '0' + hour;
            if (min < 10)
                min = '0' + min;
            this.selectedTimeStart = hour + ':' + min;

            var m = '' + (clickInfo.event.end.getMonth() + 1),
            d = '' + clickInfo.event.end.getDate(),
            Y = clickInfo.event.end.getFullYear();
            if (m.length < 2) 
                m = '0' + m;
            if (d.length < 2) 
                d = '0' + d;
            this.selectedDateEnd = Y + '-' + m + '-' + d;

            var hour = clickInfo.event.end.getHours();
            var min = clickInfo.event.end.getMinutes();
            if (hour < 10) 
                hour = '0' + hour;
            if (min < 10)
                min = '0' + min;
            this.selectedTimeEnd = hour + ':' + min;

            if(this.selectedDateStart == this.selectedDateEnd) {
                this.selectedDateEnd = false;
            }

            this.selectedService = clickInfo.event.extendedProps.service_id; // returns an id or 'null'
            
            /*this.selectedDateStart = clickInfo.start;
            this.selectedDateStart = clickInfo.end;
            this.selectedTimeStart = false;
            this.selectedTimeEnd = false;
            this.selectedService = '';*/

            $('#modal-create-package').modal('show');
        },

        deleteEvent(eventId) {
           
            var check = confirm('Wollen Sie den Eintrag wirklich löschen?'); 
            if (check) {

                var _this = this;

                axios
                .delete('/api/events/'+eventId+'?api_token='+this.apiToken)
                .then(function (response) {
                    $('#modal-create-package').modal('hide');
                    _this.getEvents();
                });

            }

        },

        handleEvents(events) {
          this.currentEvents = events
        },


        showEvent(arg) {
          this.addingMode = false;
          const { id, title, start, end } = this.events.find(
            event => event.id === +arg.event.id
          );
          this.indexToUpdate = id;
          this.newEvent = {
            event_name: title,
            start_date: start,
            end_date: end
          };
        },
        updateEvent() {
          axios
            .put("/api/calendar/" + this.indexToUpdate, {
              ...this.newEvent
            })
            .then(resp => {
              this.resetForm();
              this.getEvents();
              this.addingMode = !this.addingMode;
            })
            .catch(err =>
              console.log("Unable to update event!", err.response.data)
            );
        },
        /*deleteEvent() {
          axios
            .delete("/api/calendar/" + this.indexToUpdate)
            .then(resp => {
              this.resetForm();
              this.getEvents();
              this.addingMode = !this.addingMode;
            })
            .catch(err =>
              console.log("Unable to delete event!", err.response.data)
            );
        },*/

        resetForm() {
          Object.keys(this.newEvent).forEach(key => {
            return (this.newEvent[key] = "");
          });
        }
    },

    mounted() {
        console.log(this.calendarData);
        this.slottype = this.calendarData.slottype;
        this.services = this.servicesData;
    },

    props: ['calendarData', 'servicesData', 'apiToken']

}
</script>